import React from 'react';

type LwButtonVariant = 'primary' | 'sm' | 'sm-solid' | 'sm-danger';

const VARIANT_CLASS: Record<LwButtonVariant, string> = {
  primary: 'btn btn-primary',
  sm: 'btn-sm',
  'sm-solid': 'btn-sm solid',
  'sm-danger': 'btn-sm danger'
};

export interface LwButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: LwButtonVariant;
}

/** Brand button — primary (green) or the small footer variants. */
export function LwButton({ variant = 'primary', className, type = 'button', children, ...rest }: LwButtonProps) {
  const cls = VARIANT_CLASS[variant] + (className ? ` ${className}` : '');
  return (
    <button className={cls} type={type} {...rest}>
      {children}
    </button>
  );
}
